import { WellGroupsSvg } from './icons';
import type { LayerPattern } from '../patterns/index';

export const wellGroups: LayerPattern = {
    id: 'WellGroups',
    key: 'pad',
    title: 'Схемы кустования',
    icon: WellGroupsSvg,
    settings: [],
};
